import server from "../../../../server";
import { NoteStatus } from "../../../../domains/models/note";


export async function fetchAllNotes() {
    const res = await server.notes.list({});
    return res;
}

export async function markStatus(id: string, status: NoteStatus) {
    //status api
    const res =await server.notes.updateStatus(id,status);
}


// export async function editNote(noteId: string, data: any) {
//     const res = await server.notes.update(noteId, data);
//     return res;
// }
//
// export async function deleteNote(noteId: string) {
//     await server.notes.delete(noteId);
// }
